import React, { useState } from 'react'
import { SEOHead } from '../components/ui/SEOHead'
import { TypewriterText } from '../components/terminal/TypewriterText'
import { AsciiDivider } from '../components/terminal/AsciiDivider'
import { CategoryFilter } from '../components/blog/CategoryFilter'
import { PostList } from '../components/blog/PostList'
import { Pagination } from '../components/ui/Pagination'
import { usePosts, useCategories } from '../hooks/usePosts'

export const HomePage: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | undefined>(undefined)
  const { categories } = useCategories()
  const { posts, loading, totalPages, page, setPage, setCategory } = usePosts({
    pageSize: 10,
  })

  const handleCategorySelect = (category: string | undefined) => {
    setSelectedCategory(category)
    setCategory(category)
    setPage(1)
  }

  return (
    <>
      <SEOHead
        description="CodeToByte — a terminal-aesthetic tech blog exploring code, systems, and bytes."
        url="/"
      />

      {/* Hero */}
      <div
        style={{
          padding: '40px 0 32px',
          fontFamily: "'JetBrains Mono', 'Courier New', monospace",
        }}
      >
        <div
          style={{
            fontSize: '0.8rem',
            color: 'var(--text-muted, #555)',
            marginBottom: '12px',
          }}
        >
          <span style={{ color: 'var(--accent-green)' }}>codetobyte@blog</span>
          <span style={{ color: 'var(--text-muted)' }}>:~$</span>
          {' cat welcome.txt'}
        </div>
        <div
          style={{
            fontSize: 'clamp(1rem, 2.5vw, 1.3rem)',
            color: 'var(--text-primary)',
            minHeight: '2em',
          }}
        >
          <TypewriterText
            text="// exploring the intersection of code and bytes"
            speed={45}
          />
        </div>
        <div
          style={{
            marginTop: '16px',
            fontSize: '0.82rem',
            color: 'var(--text-secondary)',
          }}
        >
          A terminal-aesthetic tech blog. Deep dives into backend systems, search engines,
          and the craft of software.
        </div>
      </div>

      <AsciiDivider label="LATEST POSTS" width={60} />

      {categories.length > 0 && (
        <div style={{ marginBottom: '20px' }}>
          <CategoryFilter
            categories={categories}
            selectedCategory={selectedCategory}
            onSelect={handleCategorySelect}
          />
        </div>
      )}

      <PostList posts={posts} loading={loading} emptyMessage="No posts yet. Check back soon." />

      <Pagination
        currentPage={page}
        totalPages={totalPages}
        onPageChange={(p) => {
          setPage(p)
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }}
      />
    </>
  )
}
